import React, { createContext, useState } from "react";
import AdminAccessAlert from "../components/AdminAccessAlert";

// Create the context
export const AdminAccessAlertContext = createContext();

// Create the provider component
export const AdminAccessAlertProvider = ({ children }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  // Function to open the alert
  const openAlert = () => {
    setIsAlertOpen(true);
  };

  // Function to close the alert
  const closeAlert = () => {
    setIsAlertOpen(false);
  };

  return (
    <AdminAccessAlertContext.Provider value={{ isAlertOpen, openAlert, closeAlert }}>
      {children}
      {isAlertOpen && <AdminAccessAlert onClose={closeAlert} />}
    </AdminAccessAlertContext.Provider>
  );
};
